// extracted by css-extract-rspack-plugin
export default {"card":"I4IRi"};